let properties = [];
const paddingBottom = 30;
const propertiesList = document.getElementById('properties-list');

function onPropertyHover(e) {
  const text = e.currentTarget.querySelector('.cms-text');

  if (text) {
    e.currentTarget.style.setProperty('--hover-offset', `-${text.offsetHeight + paddingBottom}px`);
  } else {
    e.currentTarget.style.setProperty('--hover-offset', 0);
  }
}

function mount() {
  properties = [...document.querySelectorAll('.c-card-property:not(.no-description)')];

  properties.forEach((property) => {
    property.addEventListener('mouseenter', onPropertyHover);
  });
}

function unmount() {
  properties.forEach((property) => {
    property.removeEventListener('mouseenter', onPropertyHover);
  });

  properties = [];
}

function reset() {
  unmount();
  mount();
}

mount();
if (propertiesList) propertiesList.addEventListener('update', reset);
